import { UIFlightData } from "@flights/types";
import React from "react";
import useFlightCardBadgesListController from "./useFlightCardBadgesList.controller";
import { Stack } from "@bookingcom/bui-react";
import { FlightCardBadge } from "./FlightCardBadge";

const FlightCardBadgesList = ({ flight }: { flight: UIFlightData }) => {
  const badgesList = useFlightCardBadgesListController(flight);

  if (badgesList.length === 0) {
    return undefined;
  }

  return (
    <Stack direction="row" gap={1} alignItems="center">
      {badgesList.map((badge) => (
        <FlightCardBadge key={badge.key} {...badge} />
      ))}
    </Stack>
  );
};

export default FlightCardBadgesList;
